import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IAgentAuthSlice,
  IAgentDetails,
} from "../../models/agent/agentAuth/agentAuth";
import { agentLogin } from "./agentAuthActions";

const initialState: IAgentAuthSlice = {
  agentDetails: null,
};

const agentAuthSlice = createSlice({
  name: "agentAuth",
  initialState: initialState,
  reducers: {
    setAgentDetails: (state, { payload }: PayloadAction<IAgentDetails>) => {
      state.agentDetails = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(agentLogin.fulfilled, (state, { payload }) => {
      state.agentDetails = payload.data;
    });
  },
});

export default agentAuthSlice.reducer;

export const { setAgentDetails } = agentAuthSlice.actions;
